import React from "react";
import "./about.css";
import { Box, Divider, Stack, Typography } from "@mui/material";

const About = () => {
  const stepsList = [
    "Kick off your hen with a behind-the-scenes tour of a legendary Brighton adult boutique.",
    "Play hilarious hen games and win cheeky prizes.",
    "Follow a flirty treasure hunt through Brighton’s streets: Uncover outrageous stories, hidden histories, and scandalous secrets around every corner.",
    "Laugh, compete, and celebrate your bride in true Brighton style!",
  ];
  return (
    <div className="about-container">
      <div className="about-cloud">
        <div className="right-text-wrapper">
          {/* <h1>A</h1>
          <h1>B</h1>
          <h1>O</h1>
          <h1>U</h1>
          <h1>T</h1> */}
        </div>
        {/* <div className="cloud-blob"> */}
        <img
          src="/about2.png"
          alt="Adventure group"
          className="cloud-img-inside"
        />
        {/* </div> */}
      </div>
      <div className="about-text">
        <h2>How it <em>works</em></h2>
        <Divider sx={{ mb: 2, mx: 2 }} />
        <Stack component="ol" spacing={2} sx={{ pl: 0, listStyle: "none" }}>
          {stepsList.map((step, index) => (
            <Box
              key={index}
              component="li"
              sx={{
                display: "flex",
                alignItems: "flex-start",
                gap: 2,
                backgroundColor: "transparent !important",
                pl: 2,
              }}
            >
              <Typography
                variant="h6"
                sx={{
                  minWidth: 32,
                  height: 32,
                  borderRadius: "50%",
                  color: "white",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  fontWeight: "bold",
                  fontSize: 16,
                }}
              >
                <img src={"./down-arrow.png"} style={{
                width: "25px",
                height: "25px",
                }} alt="list" />

              </Typography>
              <Typography variant="body1" sx={{ flex: 1 }}>
                {step}
              </Typography>
            </Box>
          ))}
        </Stack>
      </div>
    </div>
  );
};

export default About;
